import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../assets/icons/warning.svg'
import _imports_1 from '../../assets/icons/refresh.svg'


const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "message-container" }
const _hoisted_3 = { class: "bold" }
const _hoisted_4 = { class: "secondary n-margin-bottom" }
const _hoisted_5 = {
  key: 0,
  class: "secondary"
}
const _hoisted_6 = { class: "buttons-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_0,
        alt: "warning"
      }, null, -1)),
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$props.errorTitle ?? _ctx.t("Trouble-creating-reference")), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$props.errorDetails ?? _ctx.t("you-can-try-again")), 1),
      (_ctx.contactSupportText)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.contactSupportText), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.tryAgainClick && _ctx.tryAgainClick(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.t("try-again")) + " ", 1),
        _cache[3] || (_cache[3] = _createElementVNode("img", {
          src: _imports_1,
          alt: "refresh"
        }, null, -1))
      ]),
      _createElementVNode("button", {
        class: "secondary",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.tryAnotherProvider && _ctx.tryAnotherProvider(...args)))
      }, _toDisplayString(_ctx.t("NoProviderReference-TryAnotherProviderButton")), 1)
    ])
  ]))
}